<template>
  <header>
    <van-nav-bar class="title-content" :title="params.title" @click-left="onClickLeft" @click-right="onClickRight" v-if="params && source !== 'app'">
      <van-icon name="arrow-left" slot="left" v-show="params.lefticon"></van-icon>
      <i :class="rightIcon" slot="right"></i>
    </van-nav-bar>
    <transition name="show">
      <van-row class="van-row nav-content" v-show="showNav">
        <van-col :span="6">
          <a :href="getMenu.home" title="首页">
            <van-icon name="wap-home"></van-icon>
            <div>首页</div>
          </a>
        </van-col>
        <van-col :span="6">
          <a :href="getMenu.category" title="商品分类">
            <van-icon class="fa fa-th-large" aria-hidden="true"></van-icon>
            <div class="m-t-3">商品分类</div>
          </a>
        </van-col>
        <van-col :span="6">
          <a :href="getMenu.mall" title="进货单">
            <van-icon name="cart"></van-icon>
            <div>进货单</div>
          </a>
        </van-col>
        <van-col :span="6">
          <a :href="getMenu.member" title="个人中心">
            <van-icon name="contact"></van-icon>
            <div>个人中心</div>
          </a>
        </van-col>
      </van-row>
    </transition>
  </header>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { mapGetters } from 'vuex'
import { NavBar, Row, Col } from 'vant'
export default {
  name: 'headers',
  components: { NavBar, Row, Col },
  props: ['params'],
  data () {
    return {
      source: getCookie('homedo_port'),
      showNav: false,
      rightIcon: 'fa fa-bars'
    }
  },
  created () {
    // 监听点击事件，控制导航隐藏
    window.onclick = (event) => {
      if (event.srcElement.className !== this.rightIcon) {
        this.showNav = false
      }
    }
    window.onscroll = () => {
      if (this.showNav) {
        this.showNav = false
      }
    }
  },
  computed: {
    ...mapGetters(['getMenu'])
  },
  methods: {
    onClickLeft () {
      if (window.history.length < 2) {
        window.location.href = '/'
      } else {
        window.history.back()
      }
    },
    onClickRight () {
      this.showNav = !this.showNav
    }
  }
}
</script>

<style scoped>
.title-content{
  font-size: 19px;
  color: #222;
  background-color: #ffffff;
  /*border-bottom: 1px solid  #D8D8D8;*/
}
.title-content .van-icon{
  color: #222;
}
.nav-content .van-icon{
  color: #fff;
  font-size: 24px;
}
.nav-content{
  padding-top: 10px;
  width: 100%;
  height: 58px;
  position: fixed;
  top: 44px;
  text-align: center;
  background: rgba(0, 0, 0, 0.75);
  z-index: 100;
  box-sizing: border-box;
}
.nav-content div{
  color: #fff;
}
.m-t-3{
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue